// admin-web/src/pages/InboxToolsPage.tsx
import { httpsCallable } from "firebase/functions";
import { useState } from "react";
import { functions } from "../firebase";

export function InboxToolsPage() {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function run(name: string) {
    setBusy(true);
    setMsg(null);
    setErr(null);
    try {
      const fn = httpsCallable(functions as any, name);
      const res: any = await fn({});
      setMsg(`✅ ${name} OK: ${JSON.stringify(res?.data ?? {}, null, 2)}`);
    } catch (e: any) {
      setErr(e?.message || `Failed to run ${name}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Inbox Tools</h2>
      <p className="muted" style={{ marginTop: 6 }}>
        Maintenance utilities for user inbox indexing (userInboxes/{`{uid}`}/threads).
      </p>

      {err ? <div className="error">{err}</div> : null}
      {msg ? (
        <pre className="card" style={{ whiteSpace: "pre-wrap", background: "rgba(0,0,0,0.03)" }}>
          {msg}
        </pre>
      ) : null}

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
        <button className="btn" disabled={busy} onClick={() => run("rebuildMyInboxIndex")}>
          {busy ? "Running…" : "Rebuild My Inbox Index"}
        </button>

        <button className="btn secondary" disabled={busy} onClick={() => run("repairClubInboxIndex")}>
          {busy ? "Running…" : "Repair Club Inbox Index"}
        </button>
      </div>

      <div className="muted" style={{ marginTop: 12, fontSize: 12 }}>
        Note: rebuildMyInboxIndex runs for the currently signed-in admin account.
      </div>
    </div>
  );
}